// extracted by mini-css-extract-plugin
export default {"resizer":"ProjectTreeResizer_resizer__Yi-ws"};